// extracted by mini-css-extract-plugin
export default {"transactions-wrapper":"transactions_transactions-wrapper__T0nom"};